import { render, staticRenderFns } from "./childrenages.vue?vue&type=template&id=7ff95e3a&"
import script from "./childrenages.vue?vue&type=script&lang=js&"
export * from "./childrenages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ff95e3a')) {
      api.createRecord('7ff95e3a', component.options)
    } else {
      api.reload('7ff95e3a', component.options)
    }
    module.hot.accept("./childrenages.vue?vue&type=template&id=7ff95e3a&", function () {
      api.rerender('7ff95e3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HeOgiPoUEP4q/JS/childrenages.vue"
export default component.exports